/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs */



/**
* | output |
* | --- |
* | "Position Events to the bottom center of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_bottom_center = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner les evenements en bas au centre de la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Positionieren Sie die Ereignisse unten in der Mitte des Videos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posiziona gli eventi al centro in basso del video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разместите события в нижней центральной части видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Colocar eventos en la parte inferior central del vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件定位到视频底部中心位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをビデオの下部中央に配置する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो के निचले केंद्र में इवेंट्स की स्थिति निर्धारित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posicione os eventos na parte inferior central do vídeo.")
	return /** @type {LocalizedString} */ ("Position Events to the bottom center of the video")
});